<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-2">
                    <button class="btn btn-primary btn-sm btn-block" 
                        @click="add()">Thêm mới</button>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="action-table-mobile">
                <div input-search>
                    
                </div>
                <div class="d-flex mb-10px">
                    <div class="w-50 pr-1">
                        <button type="button" class="btn btn-primary btn-action-check btn-block fs-14px px-1"
                            @click="add()">
                            Thêm mới
                        </button>
                    </div>
                    <div class="w-50 pl-1">
                       
                    </div>
                </div>
            </div>
         
        </div>
    </div>
</template>

<script>
export default {
    props: ['value', 'idSelect','arrPromotionStatus'],
    data() {
        return {
            loading: false,
            data: {
                category: 0,
                status: 0,
                keyword: '',
            },
            fillterMobile: false,
        }
    },
    watch: {
        value: {
            handler(val){
                this.data = val;
            },
            deep: true,
        },
    },
    created(){
       
    },
    methods: {
        emitModel(){
            this.$emit('input', {
                category: this.data.category,
                status: this.data.status,
                keyword: this.data.keyword,
            })
        },
        enterKeyword(){
            this.emitModel();
        },
        removeFillter(){
            this.data = {
                category: 0,
                status: 0,
                keyword: '',
            };
            this.emitModel();
        },
        getExp() {
            this.data.keyword = '';
            this.emitModel();
        },
        add(){
            console.log('ok');
            this.$emit('callAction', 'add')
        }
    }
}
</script>

<style lang="scss">
.ldc-model-mobile {
    .value-select-mobile {
        text-align: right;
    }
}
</style>
